import React from "react";

export type VitalType = {
  id: string;
  icon: React.ReactNode;
  name: string;
  color: string;
  backgroundColor: string;
};

interface VitalsListProps {
  className?: string;
  vitals?: VitalType[];
  activeVital?: string;
  onVitalClick?: (vitalId: string) => void;
}

const VitalsList: React.FC<VitalsListProps> = ({
  className,
  vitals,
  activeVital,
  onVitalClick,
}) => {
  return (
    <div
      className={`flex items-center gap-4 overflow-x-auto scrollbar-hide ${className}`}
    >
      {vitals?.map((vital: VitalType) => (
        <button
          key={vital.id}
          type="button"
          className={`aspect-square rounded-full flex items-center justify-center shadow-md hover:shadow-lg opacity-100 ${
            activeVital === vital.id
              ? "w-14 h-14 bg-[var(--app-primary)] text-white"
              : `w-12 h-12 bg-[${vital.backgroundColor}] text-[${vital.color}]`
          }`}
          style={{
            backgroundColor:
              activeVital === vital.id
                ? "var(--app-primary)"
                : vital.backgroundColor,
            color: activeVital === vital.id ? "white" : vital.color,
          }}
          onClick={() => onVitalClick?.(vital.id)}
        >
          {vital.icon}
        </button>
      ))}
    </div>
  );
};

export default VitalsList;
